import React from 'react';
import { LifeBuoyIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { Placeholder } from './Placeholder';
export function NeedAHand() {
  return <section id="need-a-hand" aria-labelledby="need-a-hand-title" className="relative scroll-mt-28 overflow-hidden rounded-2xl border border-white/10 bg-[#111214] p-6 text-white shadow-[0_18px_40px_-24px_rgba(0,0,0,0.9)] sm:scroll-mt-24 sm:p-9" data-id="element-62" data-mp="mxpbnysdid2v">
      <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(55%_70%_at_15%_20%,rgba(16,185,129,0.14),transparent_65%)]" aria-hidden="true" data-id="element-63" data-mp="83anljtycdhc" />

      <div className="relative" data-id="element-64" data-mp="i0yuf84u1bfv">
        <span aria-hidden="true" className="flex h-11 w-11 items-center justify-center rounded-lg border border-[#10b981]/40 bg-[#10b981]/10 text-[#10b981]" data-id="element-65" data-mp="i207fi5es808">
          <LifeBuoyIcon className="h-5 w-5" data-id="element-66" data-mp="1tearn0636vt2" />
        </span>

        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.24em] text-[#10b981]" data-id="element-67" data-mp="1ohal6o5brr1f">
          Support
        </p>
        <h2 id="need-a-hand-title" className="mt-3 font-mono text-2xl font-bold tracking-tight text-white sm:text-3xl" data-id="element-68" data-mp="3nfdwyqhhgzu0">
          Need a hand?
        </h2>
        <div className="accent-rule mt-5 h-px w-32" aria-hidden="true" data-id="element-69" data-mp="18xrvcb3veul" />

        <p className="mt-5 max-w-xl text-[15.5px] leading-relaxed text-white/85 sm:text-base" data-id="element-70" data-mp="68aepx1z8lx6">
          There are no silly questions here. If anything looks unfamiliar, message us and
          we&apos;ll jump on it — or hop on a quick call and we&apos;ll do it with you.
        </p>

        <div className="mt-7 grid gap-3 sm:max-w-xl sm:grid-cols-2" data-id="element-71" data-mp="39mo4q4bd2yog">
          <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.05] px-4 py-3.5" data-id="element-72" data-mp="3emj0om9zuegd">
            <MailIcon className="h-4 w-4 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-73" data-mp="3jgwwgpskinlk" />
            <div className="min-w-0" data-id="element-74" data-mp="2lz6a810ppmhs">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/55" data-id="element-75" data-mp="2qy9hls4604sx">
                Email us
              </p>
              <p className="mt-1 truncate text-sm font-medium" data-id="element-76" data-mp="2iws4kfhmvtag">
                <a href="mailto:support@viridiaanalytics.com" className="text-[#10b981] underline decoration-[#10b981]/40 decoration-2 underline-offset-4 transition-colors duration-200 hover:text-[#34d399]" data-id="element-77" data-mp="2dz095bhs5p1i">
                  support@viridiaanalytics.com
                </a>
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.05] px-4 py-3.5" data-id="element-78" data-mp="200sitmf91lzb">
            <PhoneIcon className="h-4 w-4 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-79" data-mp="29x57u6zunbnq" />
            <div className="min-w-0" data-id="element-80" data-mp="29usmrkysol6g">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/55" data-id="element-81" data-mp="24xsmjqommcn9">
                Call or text
              </p>
              <p className="mt-1 truncate text-sm font-medium text-white" data-id="element-82" data-mp="3leetn06gafs7">
                <Placeholder data-id="element-83" data-mp="3gcfp3myz5cto">[support phone]</Placeholder>
              </p>
            </div>
          </div>
        </div>

        <p className="mt-9 font-mono text-base font-semibold tracking-tight text-white sm:text-lg" data-id="element-84" data-mp="3nvf9nvy69aem">
          Welcome aboard — now go get those leads.
        </p>
        <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#10b981]" data-id="element-85" data-mp="3ex3kzzgv8mot">
          The Viridia Analytics team
        </p>
      </div>
    </section>;
}